// Funnel steps configuration
const steps = [
    {
        id: 0,
        type: 'age-select',
        // saleHeader: 'CHRISTMAS SALE',
        title: 'Take This 1-Minute Quiz To <span class="quiz-underline-bold">Claim Your Discount!</span>',
        question: 'How old are you?🤔',
        options: [
            { text: 'Under 30', value: 'under-30' },
            { text: '30-39', value: '30-39' },
            { text: '40-49', value: '40-49' },
            { text: '50-59', value: '50-59' },
            { text: 'Over 60', value: 'over-60' }
        ],
        hasSkip: true
    },
    {
        id: 1,
        type: 'multi-select',
        title: 'What is your biggest skin-related concern?🤷',
        subtitle: '(Choose as many as you like)',
        options: [
            { text: 'Fine Lines & Wrinkles', value: 'fine-lines-wrinkles' },
            { text: 'Dull, Tired-Looking Skin', value: 'dull-tired-skin' },
            { text: 'Dryness, Dehydration', value: 'dryness-dehydration' },
            { text: 'Dark Spots & Uneven Skin', value: 'dark-spots-uneven' }
        ]
    },
    {
        id: 2,
        type: 'multi-select',
        title: 'How deep are your wrinkles?',
        subtitle: '(Choose as many as you like)',
        options: [
            { text: 'Almost not visible', value: 'not-visible' },
            { text: 'Clearly visible', value: 'clearly-visible' },
            { text: 'Deep wrinkles', value: 'deep-wrinkles' }
        ]
    },
    {
        id: 3,
        type: 'multi-select',
        title: 'What are your main goals? 🎯',
        subtitle: '(Choose all that apply)',
        options: [
            { text: 'Smooth away fine lines & wrinkles', value: 'smooth-lines' },
            { text: 'Restore deep hydration & moisture', value: 'restore-hydration' },
            { text: 'Look younger / fight visible signs of aging', value: 'look-younger' },
            { text: 'Achieve glowing, radiant "glass skin"', value: 'glass-skin' },
            { text: 'Even out skin tone & fade dark spots', value: 'even-skin-tone' }
        ]
    },
    {
        id: 4,
        type: 'content',
        title: 'You\'re in the right place! 💪',
        content: 'Over 300,000 women have erased wrinkles and dullness from their <span class="quiz-underline">undereyes, foreheads, mouths, and necks</span> thanks to this <strong>Korean Beauty Secret!</strong>',
        hasImage: true
    },
    {
        id: 5,
        type: 'single-select-emoji',
        title: 'How often is your skin exposed to the sun?',
        subtitle: '',
        autoAdvance: true,
        options: [
            { text: 'Constantly', value: 'constantly', emoji: '🌞' },
            { text: 'Sometimes', value: 'sometimes', emoji: '🌤️' },
            { text: 'Rarely', value: 'rarely', emoji: '⛅' },
            { text: 'Almost never', value: 'never', emoji: '☁️' },
            { text: 'I am not sure', value: 'not-sure', emoji: '🤷' }
        ]
    },
    {
        id: 6,
        type: 'single-select-emoji',
        title: 'How much sleep do you usually get?💤',
        subtitle: '',
        autoAdvance: true,
        options: [
            { text: 'More than 8 hours', value: '8plus', emoji: '😴' },
            { text: '7–8 hours', value: '7-8', emoji: '👍' },
            { text: 'Less than 6 hours', value: 'less6', emoji: '🥱' },
            { text: 'My sleep is unpredictable', value: 'unpredictable', emoji: '😩' }
        ]
    },
    {
        id: 7,
        type: 'single-select-emoji',
        title: 'I feel the pressure of stress...',
        subtitle: '',
        autoAdvance: true,
        options: [
            { text: 'Every day, constantly', value: 'everyday', emoji: '😰' },
            { text: 'Most days, especially at work', value: 'mostdays', emoji: '😬' },
            { text: 'Mainly during busy periods', value: 'busy-periods', emoji: '😕' },
            { text: 'I rarely feel stressed', value: 'rarely', emoji: '😎' }
        ]
    },
    {
        id: 8,
        type: 'single-select',
        title: 'How would you describe your skin type?',
        subtitle: '',
        autoAdvance: true,
        hidden: true,
        options: [
            { text: 'Oily', value: 'oily' },
            { text: 'Dry', value: 'dry' },
            { text: 'Combination', value: 'combination' },
            { text: 'Normal', value: 'normal' },
            { text: 'Sensitive', value: 'sensitive' }
        ]
    },
    {
        id: 9,
        type: 'single-select-color',
        title: 'What is your skin tone?',
        subtitle: '',
        autoAdvance: true,
        options: [
            { text: 'Fair', value: 'fair', color: '#fdd5b1' },
            { text: 'Light', value: 'light', color: '#f4c8a8' },
            { text: 'Medium', value: 'medium', color: '#d1976f' },
            { text: 'Dark', value: 'dark', color: '#8b5a3c' },
            { text: 'Very Dark', value: 'very-dark', color: '#5c4033' },
            { text: 'I am not sure', value: 'not-sure', emoji: '❓' }
        ]
    },
    {
        id: 10,
        type: 'single-select',
        title: 'Do you have sensitive skin🤔?',
        subtitle: '',
        autoAdvance: true,
        options: [
            { text: 'Yes', value: 'yes' },
            { text: 'No', value: 'no' },
            { text: 'I am not sure', value: 'not-sure' }
        ]
    },
    {
        id: 11,
        type: 'content',
        title: 'Congratulations, you may be a great fit ✅',
        content: 'Your answers show that your skin may benefit from deep collagen support that works with your skin barrier, not against it.',
        hasSingleImage: true,
        imageUrl: 'https://levanity.vercel.app/images/great-fit.jpg'
    },
    {
        id: 12,
        type: 'spinner',
        text: 'Creating your skin profile...'
    },
    {
        id: 13,
        type: 'summary',
        title: 'Summary of your Skin Profile',
        metric: 'Natural Collagen Loss',
        level: 'HIGH',
        description: 'High levels of natural collagen loss can lead to deep wrinkles, sagginess and an uneven complexion making you look years older than you feel.'
    },
    {
        id: 14,
        type: 'multi-select',
        title: 'What solutions have you tried before? <br> (Choose all that apply)',
        subtitle: '<span style="font-weight: bold; color: #000; font-size: 1rem;"></span>',
        options: [
            { text: 'In-clinic treatments', subtext: 'Botox, Fillers, Microneedling, Laser', value: 'clinic-treatments', emoji: '💉' },
            { text: 'Anti-Aging Products', subtext: 'Retinol, Serums, Creams, Vitamin C', value: 'anti-aging', emoji: '🧴' },
            { text: 'Supplements or Powders', value: 'supplements', emoji: '💊' },
            { text: 'Natural/home remedies', value: 'natural-remedies', emoji: '🌿' },
            { text: 'Others', value: 'others', emoji: '❌' },
            { text: 'Nothing yet', value: 'nothing-yet', emoji: '🤷' }
        ]
    },
    {
        id: 15,
        type: 'spinner',
        text: 'Finding the best solution for you...',
        hidden: true
    },
    {
        id: 16,
        type: 'content',
        title: 'Don\'t worry if other solutions haven\'t worked for you…',
        content: '99% of topical anti-aging products can\'t penetrate deeply enough to create lasting change.<br><br>Our <strong>Collagen Glow Up Mask</strong> uses 166-dalton collagen—small enough to move beyond the surface layer and support visible skin renewal where firmness and elasticity begin.',
        hasSingleStaticImage: true,
        imageUrl: 'https://levanity.vercel.app/images/dont-worry.jpg'
    },
    {
        id: 17,
        type: 'single-select',
        title: 'How much time do you have for daily skincare? ⏱️',
        subtitle: '',
        autoAdvance: true,
        options: [
            { text: 'I don\'t have time every day', value: 'no-time' },
            { text: '5 minutes', value: '5-min' },
            { text: '10 minutes', value: '10-min' },
            { text: '15 minutes', value: '15-min' },
            { text: '20 minutes', value: '20-min' },
            { text: 'I am not sure', value: 'not-sure' }
        ]
    },
    {
        id: 18,
        type: 'loading-page',
        title: 'A busy schedule doesn\'t have to stop you from looking radiant and years younger…',
        subtitle: 'With this <span class="quiz-underline-text">Korean ritual</span>, you can wake up to plumper, glowing skin—just by wearing it overnight while you sleep.<br><br><span class="quiz-underline-text">No needles or 7-step routine.</span> No wasted time. Just one simple step, once or twice a week, for results you can see by morning.',
        loadingText: 'Loading next question...'
    },
    {
        id: 19,
        type: 'single-select',
        title: 'Have you ever felt like your skin makes you look older than you feel inside? 🤔',
        subtitle: '',
        autoAdvance: true,
        options: [
            { text: 'Yes', value: 'yes' },
            { text: 'No', value: 'no' },
            { text: 'Sometimes', value: 'sometimes' }
        ]
    },
    {
        id: 20,
        type: 'single-select',
        title: 'What would it feel like to see a glowing, younger version of yourself in the mirror again?',
        subtitle: '',
        autoAdvance: true,
        options: [
            { text: 'I\'d feel a surge of confidence', value: 'surge-confidence', emoji: '👑' },
            { text: 'I\'d be proud of myself', value: 'proud', emoji: '👍'  },
            { text: 'I\'d feel sexier', value: 'sexier', emoji: '💋'  },
            { text: 'All of the above', value: 'all', emoji: '💍'  }
        ]
    },
    {
        id: 21,
        type: 'single-select-emoji',
        title: 'Do you have an important event coming up?',
        subtitle: 'Having something to look forward to can be a great motivator for reaching your goal',
        autoAdvance: true,
        options: [
            { text: 'Birthday', value: 'birthday', emoji: '🎁' },
            { text: 'Holiday', value: 'holiday', emoji: '🏖️' },
            { text: 'Reunion', value: 'reunion', emoji: '👫' },
            { text: 'Sporting Event', value: 'sporting', emoji: '🥇' },
            { text: 'Other', value: 'other', emoji: '⭐' },
            { text: 'No Events any time soon', value: 'no-events', emoji: '❌' }
        ]
    },
    {
        id: 22,
        type: 'date-picker',
        title: 'When is your event?',
        subtitle: 'We will keep this in mind for your treatment.',
        placeholder: 'Select Date',
        hasSkip: true
    },
    {
        id: 23,
        type: 'spinner',
        text: 'Calculating possible results for your skin type...'
    },
    {
        id: 24,
        type: 'results-comparison',
        subtitle: 'Based on your answers:',
        title: 'You Are Just 2-3 Weeks Away From Fully Rejuvenated Skin!',
        expectationsTitle: 'Here\'s what you can expect:',
        expectations: [
            '✅ First visible results after just 1 treatment.',
            '✅ With continued use over 3–4 weeks, skin will appear firmer and more elastic, with smoother texture, softened lines, and a healthier, more youthful glow.',
        ],
        beforeImage: 'https://levanity.vercel.app/images/now.png',
        afterImage: 'https://levanity.vercel.app/images/your-goal.png'
    },
    {
        id: 25,
        type: 'spinner',
        text: 'Applying special one-time discount...'
    }
];


// State management
let currentStep = 0;
let userSelections = {};
let answers = {};
let currentCarouselIndex = 0;
let carouselInterval = null;


// Initialize - handles both pre-loaded and loading states
function initializeQuiz() {
    // Wait a bit for Shopify to finish loading
    setTimeout(() => {
        renderStep();
    }, 100);
}


// Check if DOM is already loaded, otherwise wait for it
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeQuiz);
} else {
    // DOM already loaded
    initializeQuiz();
}


function renderStep() {
    const step = steps[currentStep];
    const mainContent = document.getElementById('quiz-mainContent');


    updateProgress();


    // Add step ID as data attribute for styling
    mainContent.setAttribute('data-step-id', step.id);


    // Stop carousel auto-rotation when changing steps
    stopCarouselAutoRotation();
    currentCarouselIndex = 0;


    switch (step.type) {
        case 'age-select':
            renderAgeSelect(step, mainContent);
            break;
        case 'multi-select':
            renderMultiSelect(step, mainContent);
            break;
        case 'single-select':
        case 'single-select-emoji':
        case 'single-select-color':
            renderSingleSelect(step, mainContent);
            break;
        case 'image-grid':
            renderImageGrid(step, mainContent);
            break;
        case 'content':
            renderContent(step, mainContent);
            break;
        case 'spinner':
            renderSpinner(step, mainContent);
            break;
        case 'loading-page':
            renderLoadingPage(step, mainContent);
            break;
        case 'summary':
            renderSummary(step, mainContent);
            break;
        case 'date-picker':
            renderDatePicker(step, mainContent);
            break;
        case 'results-comparison':
            renderResultsComparison(step, mainContent);
            break;
    }
}


function renderAgeSelect(step, container) {
    container.innerHTML = `
        ${step.saleHeader ? `<div class="quiz-sale-header">${step.saleHeader}</div>` : ''}
        <div class="quiz-age-select-title">${step.title}</div>
        <div class="quiz-age-question">${step.question}</div>
        <div class="quiz-options-container">
            ${step.options.map(option => `
                <button class="quiz-option-button quiz-age-option" data-value="${option.value}">
                    ${option.text}
                </button>
            `).join('')}
        </div>
        ${step.hasSkip ? '<button class="quiz-skip-link">SKIP THIS STEP</button>' : ''}


       <div class="quiz-terms-disclaimer">
            By clicking any of the options above, you agree with the<br>
            <a href="https://levanity.com/policies/terms-of-service" class="quiz-blue-link" target="_blank">Terms of Use and Service</a> and <a href="https://levanity.com/policies/privacy-policy" class="quiz-blue-link" target="_blank">Privacy Policy</a>.
        </div>
    `;


    // Add skip button event listener
    const skipButton = container.querySelector('.quiz-skip-link');
    if (skipButton) {
        skipButton.addEventListener('click', skipToLastPage);
    }


    const buttons = container.querySelectorAll('.quiz-option-button');
    buttons.forEach(button => {
        button.addEventListener('click', () => {
            updateAnswers(step.id, button.dataset.value);
            setTimeout(() => nextStep(), 300);
        });
    });
}


function renderMultiSelect(step, container) {
    container.innerHTML = `
        <div class="quiz-question-title">${step.title}</div>
        <div class="quiz-question-subtitle">${step.subtitle}</div>
        <div class="quiz-options-container">
            ${step.options.map(option => `
                <button class="quiz-option-button" data-value="${option.value}">
                    ${option.emoji ? `<span class="quiz-emoji">${option.emoji}</span>` : ''}
                    <div class="quiz-option-text-container">
                        <div class="quiz-option-main-text">${option.text}</div>
                        ${option.subtext ? `<div class="quiz-option-subtext">${option.subtext}</div>` : ''}
                    </div>
                    <span class="quiz-checkmark">✓</span>
                </button>
            `).join('')}
        </div>
        ${false ? '<button class="quiz-back-button">← Back</button>' : ''}
        ${wrapContinueButton(`<button class="quiz-continue-button">
            Continue →
        </button>`)}
    `;


    // Add continue button event listener
    const continueButton = container.querySelector('.quiz-continue-button');
    if (continueButton) {
        continueButton.addEventListener('click', nextStep);
    }


    // Add click handlers
    const buttons = container.querySelectorAll('.quiz-option-button');
    buttons.forEach(button => {
        button.addEventListener('click', () => {
            button.classList.toggle('quiz-selected');
            updateAnswers(step.id, getSelectedValues(buttons));
        });
    });
}


function renderSingleSelect(step, container) {
    // Add specific styles for step 21 (important event)
    const titleStyle = step.id === 21 ? ' style="margin-bottom: 20px;"' : '';
    const subtitleStyle = step.id === 21 ? ' style="font-weight: normal;"' : '';


    container.innerHTML = `
        <div class="quiz-question-title"${titleStyle}>${step.title}</div>
        ${step.subtitle ? `<div class="quiz-question-subtitle"${subtitleStyle}>${step.subtitle}</div>` : ''}
        <div class="quiz-options-container">
            ${step.options.map(option => `
                <button class="quiz-option-button" data-value="${option.value}">
                    ${option.emoji ? `<span class="quiz-emoji">${option.emoji}</span>` : ''}
                    ${option.color ? `<span class="quiz-color-circle" style="background-color: ${option.color}"></span>` : ''}
                    ${option.text}
                </button>
            `).join('')}
        </div>
        ${false ? '<button class="quiz-back-button">← Back</button>' : ''}
        ${!step.autoAdvance ? wrapContinueButton(`<button class="quiz-continue-button">
            Continue →
        </button>`) : ''}
    `;


    // Add continue button event listener (only if not auto-advance)
    if (!step.autoAdvance) {
        const continueButton = container.querySelector('.quiz-continue-button');
        if (continueButton) {
            continueButton.addEventListener('click', nextStep);
        }
    }


    const buttons = container.querySelectorAll('.quiz-option-button');


    buttons.forEach(button => {
        button.addEventListener('click', () => {
            buttons.forEach(b => b.classList.remove('quiz-selected'));
            button.classList.add('quiz-selected');
            updateAnswers(step.id, button.dataset.value);


            // Auto-advance to next step if enabled
            if (step.autoAdvance) {
                setTimeout(() => nextStep(), 300);
            }
        });
    });
}


function renderImageGrid(step, container) {
    container.innerHTML = `
        <div class="quiz-question-title">${step.title}</div>
        <div class="quiz-question-subtitle">${step.subtitle}</div>
        <div class="quiz-image-grid">
            ${step.options.map(option => `
                <div class="quiz-image-option" data-value="${option.value}">
                    <img src="${option.image}" alt="${option.text}">
                    <div class="quiz-label">${option.text}</div>
                    <div class="quiz-check-badge">✓</div>
                </div>
            `).join('')}
        </div>
        ${false ? '<button class="quiz-back-button">← Back</button>' : ''}
        ${wrapContinueButton(`<button class="quiz-continue-button">
            Continue →
        </button>`)}
    `;


    // Add continue button event listener
    const continueButton = container.querySelector('.quiz-continue-button');
    if (continueButton) {
        continueButton.addEventListener('click', nextStep);
    }


    const options = container.querySelectorAll('.quiz-image-option');
    options.forEach(option => {
        option.addEventListener('click', () => {
            option.classList.toggle('quiz-selected');
            updateAnswers(step.id, getSelectedValues(options));
        });
    });
}


function renderContent(step, container) {
    let additionalContent = '';


    if (step.hasSingleStaticImage && step.imageUrl) {
        additionalContent = `
            <div class="quiz-single-image-container" style="margin: 20px auto; max-width: 281px;">
                <img src="${step.imageUrl}" alt="${step.title}" style="width: 100%; height: auto; border-radius: 12px;">
            </div>
        `;
    } else if (step.hasImage) {
        const images = [
            'https://levanity.vercel.app/images/carousel-1.jpg',
            'https://levanity.vercel.app/images/carousel-2.jpg',
            'https://levanity.vercel.app/images/carousel-3.jpg'
        ];


        const imagesHtml = images.map(src => `
            <img src="${src}" alt="Before and After" class="quiz-carousel-image">
        `).join('');


        const dotsHtml = images.map((_, index) => `
            <button class="quiz-carousel-dot ${index === 0 ? 'quiz-active' : ''}" data-index="${index}" aria-label="View image ${index + 1}"></button>
        `).join('');


        additionalContent = `
            <div class="quiz-carousel-container">
                <div class="quiz-carousel-strip" id="quiz-carousel-strip">
                    ${imagesHtml}
                </div>
                <div class="quiz-carousel-dots">
                    ${dotsHtml}
                </div>
            </div>
        `;
    }


    if (step.hasSingleImage && step.imageUrl) {
        container.innerHTML = `
            <div class="quiz-content-page">
                <h2 style="margin-bottom: 15px;">${step.title}</h2>
                <p class="quiz-content-text" style="font-size: 1.7em; font-weight: bold; margin-bottom: 20px; line-height: 1.3;">${step.content}</p>
                ${wrapContinueButton(`<button class="quiz-continue-button" style="margin: 20px auto; display: block;">Continue →</button>`)}
                <div class="quiz-single-image-container" style="margin: 20px auto 30px; max-width: 375px;">
                    <img src="${step.imageUrl}" alt="${step.title}" style="width: 100%; height: auto; border-radius: 12px;">
                </div>
            </div>
        `;


        // Add continue button event listener
        const continueButton = container.querySelector('.quiz-continue-button');
        if (continueButton) {
            continueButton.addEventListener('click', nextStep);
        }


        return;
    }


    if (step.hasAvatars) {
        additionalContent = `<div class="quiz-user-avatars">...</div>`;
    }


    container.innerHTML = `
        <div class="quiz-content-page">
            <h2>${step.title}</h2>
            <p>${step.content}</p>
            ${additionalContent}
        </div>
        ${wrapContinueButton(`<button class="quiz-continue-button">Continue →</button>`)}
    `;


    // Add continue button event listener
    const continueButton = container.querySelector('.quiz-continue-button');
    if (continueButton) {
        continueButton.addEventListener('click', nextStep);
    }


    // Add carousel dot event listeners
    const carouselDots = container.querySelectorAll('.quiz-carousel-dot');
    carouselDots.forEach(dot => {
        dot.addEventListener('click', () => {
            const index = parseInt(dot.dataset.index);
            changeCarouselImage(index);
        });
    });


    // Initialize carousel dragging and auto-rotation
    if (step.hasImage && !step.hasSingleStaticImage) {
        setTimeout(() => {
            initCarousel();
        }, 100);
    }
}


function renderSpinner(step, container) {
    container.innerHTML = `
        <div class="quiz-loading-page">
            <div class="quiz-spinner" id="quiz-spinner"></div>
            <div class="quiz-checkmark" id="quiz-checkmark"></div>
            <div class="quiz-loading-bottom-text">${step.text}</div>
        </div>
    `;


    // 1. Show the spinner and text for 1.5 seconds
    setTimeout(() => {
        const spinner = document.getElementById('quiz-spinner');
        const checkmark = document.getElementById('quiz-checkmark');


        if (spinner) spinner.classList.add('quiz-hidden');
        if (checkmark) checkmark.classList.add('quiz-show');


        // 2. Show the checkmark for 1 second, then trigger the final redirect
        setTimeout(() => {
            nextStep();
        }, 1000);
    }, 1500);
}


function renderLoadingPage(step, container) {
    container.innerHTML = `
        <div class="quiz-loading-page">
            <h1 class="quiz-loading-title">${step.title}</h1>
            <p class="quiz-loading-subtitle">${step.subtitle}</p>
            <div class="quiz-spinner" id="quiz-spinner"></div>
            <div class="quiz-checkmark" id="quiz-checkmark"></div>
            <div class="quiz-loading-bottom-text">${step.loadingText}</div>
        </div>
    `;


    // Show spinner for 5 seconds
    setTimeout(() => {
        const spinner = document.getElementById('quiz-spinner');
        const checkmark = document.getElementById('quiz-checkmark');


        // Hide spinner
        spinner.classList.add('quiz-hidden');


        // Show checkmark
        checkmark.classList.add('quiz-show');


        // Show checkmark for 3 seconds, then advance
        setTimeout(() => {
            nextStep();
        }, 3000);
    }, 5000);
}


function renderSummary(step, container) {
    container.innerHTML = `
        <div class="quiz-content-page">
            <h2>${step.title}</h2>
            <div class="quiz-summary-card">
                <h3>
                    ${step.metric}
                    <span class="quiz-badge">${step.level}</span>
                </h3>
                <img src="https://levanity.vercel.app/images/skin-profile.png" alt="Skin Profile" style="width: 100%; max-width: 169px; height: auto; margin: 10px auto; border-radius: 12px; display: block;">
                <div class="quiz-slider-container">
                    <div class="quiz-slider">
                        <div class="quiz-slider-thumb">
                            <div class="quiz-slider-label">Your level</div>
                        </div>
                    </div>
                    <div class="quiz-slider-labels">
                        <span>Low</span>
                        <span>Normal</span>
                        <span>Medium</span>
                        <span>High</span>
                    </div>
                </div>
                <div class="quiz-alert-box">
                    <div class="quiz-alert-header">
                        <div class="quiz-icon">⚠</div>
                        <div class="quiz-title">${step.level} level</div>
                    </div>
                    <div class="quiz-description">${step.description}</div>
                </div>
            </div>
            <div class="quiz-info-cards-grid">
                <div class="quiz-info-card">
                    <div class="quiz-info-icon"><img src="https://cdn.shopify.com/s/files/1/0717/1283/3787/files/magnifying-glass_1.png?v=1751447643" alt="Noticeable" style="width: 30px; height: 30px;"></div>
                    <div class="quiz-info-content">
                        <div class="quiz-info-label">Impact on Appearance</div>
                        <div class="quiz-info-value">Noticeable</div>
                    </div>
                </div>
                <div class="quiz-info-card">
                    <div class="quiz-info-icon"><img src="https://cdn.shopify.com/s/files/1/0717/1283/3787/files/analytic_1.png?v=1751447643" alt="Room For Improvement" style="width: 30px; height: 30px;"></div>
                    <div class="quiz-info-content">
                        <div class="quiz-info-label">Room For Improvement</div>
                        <div class="quiz-info-value">High</div>
                    </div>
                </div>
                <div class="quiz-info-card">
                    <div class="quiz-info-icon"><img src="https://cdn.shopify.com/s/files/1/0717/1283/3787/files/elasticity_1.png?v=1751447643" alt="Skin Elasticity" style="width: 30px; height: 30px;"></div>
                    <div class="quiz-info-content">
                        <div class="quiz-info-label">Skin Elasticity</div>
                        <div class="quiz-info-value">Low</div>
                    </div>
                </div>
                <div class="quiz-info-card">
                    <div class="quiz-info-icon"><img src="https://cdn.shopify.com/s/files/1/0717/1283/3787/files/collagen_4.png?v=1751447643" alt="Natural Collagen" style="width: 30px; height: 30px;"></div>
                    <div class="quiz-info-content">
                        <div class="quiz-info-label">Natural Collagen Levels</div>
                        <div class="quiz-info-value">Below Average</div>
                    </div>
                </div>
            </div>
        </div>
        ${false ? '<button class="quiz-back-button">← Back</button>' : ''}
        ${wrapContinueButton(`<button class="quiz-continue-button">
            Continue →
        </button>`)}
    `;


    // Add continue button event listener
    const continueButton = container.querySelector('.quiz-continue-button');
    if (continueButton) {
        continueButton.addEventListener('click', nextStep);
    }
}


function renderDatePicker(step, container) {
    container.innerHTML = `
        <div class="quiz-date-picker-page">
            <h2 class="quiz-question-title">${step.title}</h2>
            <p class="quiz-question-subtitle">${step.subtitle}</p>


            <div class="quiz-date-picker-wrapper" id="quiz-datePickerWrapper">
                <div class="quiz-date-input-container" id="quiz-dateInputContainer">
                    <svg class="quiz-calendar-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                        <line x1="16" y1="2" x2="16" y2="6"></line>
                        <line x1="8" y1="2" x2="8" y2="6"></line>
                        <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                    <input type="text"
                           class="quiz-date-input"
                           id="quiz-dateInput"
                           placeholder="${step.placeholder}"
                           readonly>
                </div>
                <div class="quiz-error-message" id="quiz-errorMessage">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M8 1L1 15h14L8 1z" stroke="#dc2626" stroke-width="2" fill="none"/>
                        <line x1="8" y1="6" x2="8" y2="10" stroke="#dc2626" stroke-width="2"/>
                        <circle cx="8" cy="12" r="0.5" fill="#dc2626"/>
                    </svg>
                    Please select a date.
                </div>
                <div class="quiz-calendar-popup" id="quiz-calendarPopup"></div>
            </div>
        </div>
        ${false ? '<button class="quiz-back-button">← Back</button>' : ''}
        ${wrapContinueButton(`<button class="quiz-continue-button" id="quiz-continueBtn">
            Continue →
        </button>`)}
        ${step.hasSkip ? '<button class="quiz-skip-link">Skip this step</button>' : ''}
    `;


    // Add continue button event listener
    const continueButton = container.querySelector('.quiz-continue-button');
    if (continueButton) {
        continueButton.addEventListener('click', validateAndContinue);
    }


    // Add skip button event listener
    const skipButton = container.querySelector('.quiz-skip-link');
    if (skipButton) {
        skipButton.addEventListener('click', skipToEnd);
    }


    // Initialize date picker functionality
    initDatePicker();
}


function initDatePicker() {
    const dateInput = document.getElementById('quiz-dateInput');
    const dateInputContainer = document.getElementById('quiz-dateInputContainer');
    const calendarPopup = document.getElementById('quiz-calendarPopup');
    let selectedDate = null;


    // Initialize with current date
    const now = new Date();
    let currentViewMonth = now.getMonth();
    let currentViewYear = now.getFullYear();


    // Move calendar inside input container for proper positioning
    dateInputContainer.appendChild(calendarPopup);
    dateInputContainer.style.position = 'relative';


    // Toggle calendar on input click
    dateInputContainer.addEventListener('click', () => {
        const isOpen = calendarPopup.classList.contains('quiz-show');
        if (isOpen) {
            closeCalendar();
        } else {
            openCalendar();
        }
    });


    function openCalendar() {
        calendarPopup.innerHTML = generateCalendar(currentViewMonth, currentViewYear);
        calendarPopup.classList.add('quiz-show');
        attachCalendarListeners();
    }


    function closeCalendar() {
        calendarPopup.classList.remove('quiz-show');
    }


    function generateCalendar(month, year) {
        const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
                          'July', 'August', 'September', 'October', 'November', 'December'];


        const firstDay = new Date(year, month, 1);
        const lastDay = new Date(year, month + 1, 0);
        const daysInMonth = lastDay.getDate();
        const startingDayOfWeek = firstDay.getDay();


        // Generate year options (1900 to current year + 10)
        const currentYear = new Date().getFullYear();
        let yearOptions = '';
        for (let y = 1900; y <= currentYear + 10; y++) {
            yearOptions += `<option value="${y}" ${y === year ? 'selected' : ''}>${y}</option>`;
        }


        // Generate month options
        let monthOptions = '';
        monthNames.forEach((name, idx) => {
            monthOptions += `<option value="${idx}" ${idx === month ? 'selected' : ''}>${name}</option>`;
        });


        let calendarHTML = `
            <div class="quiz-calendar-header">
                <select class="quiz-calendar-month-select" id="quiz-monthSelect">
                    ${monthOptions}
                </select>
                <select class="quiz-calendar-year-select" id="quiz-yearSelect">
                    ${yearOptions}
                </select>
            </div>
            <div class="quiz-calendar-weekdays">
                <div>Mon</div>
                <div>Tue</div>
                <div>Wed</div>
                <div>Thu</div>
                <div>Fri</div>
                <div>Sat</div>
                <div>Sun</div>
            </div>
            <div class="quiz-calendar-days">
        `;


        // Add quiz-empty cells for days before the first day of month
        const adjustedStartDay = startingDayOfWeek === 0 ? 6 : startingDayOfWeek - 1;
        for (let i = 0; i < adjustedStartDay; i++) {
            calendarHTML += '<div class="quiz-calendar-day quiz-empty"></div>';
        }


        // Add days of the month
        for (let day = 1; day <= daysInMonth; day++) {
            calendarHTML += `<div class="quiz-calendar-day" data-date="${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}">${day}</div>`;
        }


        calendarHTML += '</div>';
        return calendarHTML;
    }


    function attachCalendarListeners() {
        // Month and year dropdown listeners
        const monthSelect = document.getElementById('quiz-monthSelect');
        const yearSelect = document.getElementById('quiz-yearSelect');


        if (monthSelect) {
            // Prevent dropdown clicks from closing calendar
            monthSelect.addEventListener('click', (e) => {
                e.stopPropagation();
            });


            monthSelect.addEventListener('change', (e) => {
                e.stopPropagation();
                currentViewMonth = parseInt(e.target.value);
                calendarPopup.innerHTML = generateCalendar(currentViewMonth, currentViewYear);
                attachCalendarListeners();
            });


            // Prevent mousedown from triggering calendar toggle
            monthSelect.addEventListener('mousedown', (e) => {
                e.stopPropagation();
            });
        }


        if (yearSelect) {
            // Prevent dropdown clicks from closing calendar
            yearSelect.addEventListener('click', (e) => {
                e.stopPropagation();
            });


            yearSelect.addEventListener('change', (e) => {
                e.stopPropagation();
                currentViewYear = parseInt(e.target.value);
                calendarPopup.innerHTML = generateCalendar(currentViewMonth, currentViewYear);
                attachCalendarListeners();
            });


            // Prevent mousedown from triggering calendar toggle
            yearSelect.addEventListener('mousedown', (e) => {
                e.stopPropagation();
            });
        }


        // Prevent calendar popup clicks from closing it
        calendarPopup.addEventListener('click', (e) => {
            e.stopPropagation();
        });


        // Day selection listeners
        const days = document.querySelectorAll('.quiz-calendar-day:not(.quiz-empty)');
        days.forEach(day => {
            day.addEventListener('click', (e) => {
                e.stopPropagation();
                const dateValue = e.target.dataset.date;
                selectedDate = dateValue;


                // Format date for display
                const date = new Date(dateValue);
                const options = { year: 'numeric', month: 'long', day: 'numeric' };
                dateInput.value = date.toLocaleDateString('en-US', options);


                // Store the selected date
                updateAnswers(22, dateValue);


                // Remove error state if present
                dateInputContainer.classList.remove('quiz-error');
                document.getElementById('quiz-errorMessage').classList.remove('quiz-show');


                // Close calendar
                closeCalendar();
            });
        });
    }


    // Close calendar when clicking outside
    document.addEventListener('click', (e) => {
        const datePickerWrapper = document.getElementById('quiz-datePickerWrapper');
        if (datePickerWrapper && !datePickerWrapper.contains(e.target)) {
            closeCalendar();
        }
    });
}


function validateAndContinue() {
    const dateInput = document.getElementById('quiz-dateInput');
    const dateInputContainer = document.getElementById('quiz-dateInputContainer');
    const errorMessage = document.getElementById('quiz-errorMessage');


    if (!dateInput.value) {
        // Show error state
        dateInputContainer.classList.add('quiz-error', 'quiz-shake');
        errorMessage.classList.add('quiz-show');


        // Remove shake animation after it completes
        setTimeout(() => {
            dateInputContainer.classList.remove('quiz-shake');
        }, 500);
    } else {
        // Valid date quiz-selected, proceed to next step
        nextStep();
    }
}


function renderResultsComparison(step, container) {
    container.innerHTML = `
        <div class="quiz-results-comparison-page">
            <div class="quiz-results-subtitle">${step.subtitle}</div>
            <h1 class="quiz-results-title">${step.title}</h1>
            <div class="quiz-expectations-title">${step.expectationsTitle}</div>


            <div class="quiz-expectations-list">
                ${step.expectations.map(expectation => `
                    <div class="quiz-expectation-item">
                        <span class="quiz-expectation-text">${expectation}</span>
                    </div>
                `).join('')}
            </div>


            <div class="quiz-comparison-cards">
                <div class="quiz-comparison-card before-card">
                    <div class="quiz-card-badge quiz-now-badge">Now</div>
                    <div class="quiz-card-image">
                        <img src="${step.beforeImage}" alt="Current skin condition">
                    </div>
                    <div class="quiz-metrics">
                        <div class="quiz-metric-item skin-elasticity">
                            <div class="quiz-metric-label">Skin Elasticity</div>
                            <div class="quiz-metric-value">Low</div>
                            <div class="quiz-metric-bar">
                                <div class="quiz-metric-fill quiz-red-fill" style="width: 33.33%"></div>
                            </div>
                        </div>
                        <div class="quiz-metric-item">
                            <div class="quiz-metric-label">Wrinkles & Lines</div>
                            <div class="quiz-metric-value">Moderate to Deep</div>
                            <div class="quiz-metric-bar">
                                <div class="quiz-metric-fill quiz-red-fill" style="width: 33.33%"></div>
                            </div>
                        </div>
                        <div class="quiz-metric-item">
                            <div class="quiz-metric-label">Collagen Levels</div>
                            <div class="quiz-metric-value">Below Average</div>
                            <div class="quiz-metric-bar">
                                <div class="quiz-metric-fill quiz-red-fill" style="width: 33.33%"></div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="quiz-arrow-container">
                    <span class="quiz-arrow-icon">&gt;</span>
                </div>


                <div class="quiz-comparison-card after-card">
                    <div class="quiz-card-badge quiz-goal-badge">Your Goal</div>
                    <div class="quiz-card-image">
                        <img src="${step.afterImage}" alt="Your goal skin condition">
                    </div>
                    <div class="quiz-metrics">
                        <div class="quiz-metric-item skin-elasticity">
                            <div class="quiz-metric-label">Skin Elasticity</div>
                            <div class="quiz-metric-value">Firmed up</div>
                            <div class="quiz-metric-bar">
                                <div class="quiz-metric-fill quiz-green-fill" style="width: 100%"></div>
                            </div>
                        </div>
                        <div class="quiz-metric-item">
                            <div class="quiz-metric-label">Wrinkles & Lines</div>
                            <div class="quiz-metric-value">Visibly Erased</div>
                            <div class="quiz-metric-bar">
                                <div class="quiz-metric-fill quiz-green-fill" style="width: 100%"></div>
                            </div>
                        </div>
                        <div class="quiz-metric-item">
                            <div class="quiz-metric-label">Collagen Levels</div>
                            <div class="quiz-metric-value">High</div>
                            <div class="quiz-metric-bar">
                                <div class="quiz-metric-fill quiz-green-fill" style="width: 100%"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
        ${false ? '<button class="quiz-back-button">← Back</button>' : ''}
        <div class="quiz-fixed-button-wrapper">
            <button class="quiz-claim-discount-button" id="quiz-claimDiscountBtn">
                <span class="quiz-button-spinner quiz-hidden"></span>
                <span class="quiz-button-checkmark quiz-hidden">✓</span>
                <span class="quiz-button-text">CLAIM YOUR DISCOUNT</span>
                <svg class="quiz-button-arrow" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
        </div>
    `;


    // Add claim discount button event listener
    const claimButton = container.querySelector('.quiz-claim-discount-button');
    if (claimButton) {
        claimButton.addEventListener('click', claimDiscountWithAnimation);
    }
}


function getSelectedValues(elements) {
    return Array.from(elements)
        .filter(el => el.classList.contains('quiz-selected'))
        .map(el => el.dataset.value);
}


function wrapContinueButton(buttonHtml) {
    // Step 11 (Congratulations): button in the middle (no wrapper)
    // Step 22 (When is your event): keep as is (no wrapper)
    // Step 24 (3 months away): doesn't use this function, has its own button
    // All other steps: fixed wrapper at bottom
    if (currentStep === 11 || currentStep === 22) {
        return buttonHtml; // No wrapper for these specific steps
    }
    return `<div class="quiz-fixed-button-wrapper">${buttonHtml}</div>`;
}


function updateAnswers(stepId, value) {
    answers[stepId] = value;
}


function updateProgress() {
    const progress = ((currentStep + 1) / steps.length) * 100;
    const progressFill = document.getElementById('quiz-progressFill');


    if (progressFill) {
        // Use setProperty with 'important' to override Shopify CSS
        progressFill.style.setProperty('width', `${progress}%`, 'important');
    }
}


function nextStep() {
    if (currentStep < steps.length - 1) {
        currentStep++;
        // Skip quiz-hidden steps
        while (currentStep < steps.length && steps[currentStep].hidden) {
            currentStep++;
        }
        if (currentStep < steps.length) {
            renderStep();
            window.scrollTo(0, 0);
        } else {
            // Funnel complete - redirect to offer page
            window.location.href = 'https://levanity.com/products/le-bio-collagen-mask';
        }
    } else {
        // Funnel complete - redirect to offer page
        window.location.href = 'https://levanity.com/products/le-bio-collagen-mask';
    }
}


function skipToEnd() {
    currentStep = steps.length - 2;
    renderStep();
    window.scrollTo(0, 0);
}


function skipToLastPage() {
    // Finds the index of the very last spinner in the funnel (the "Applying Discount" step)
    const lastSpinnerIndex = steps.map(s => s.type).lastIndexOf('spinner');
   
    if (lastSpinnerIndex !== -1) {
        currentStep = lastSpinnerIndex;
        renderStep();
        window.scrollTo(0, 0);
    } else {
        // Fallback: if no spinner is found, go to the absolute end
        currentStep = steps.length - 1;
        renderStep();
    }
}


function previousStep() {
    if (currentStep > 0) {
        currentStep--;
        // Skip quiz-hidden steps
        while (currentStep > 0 && steps[currentStep].hidden) {
            currentStep--;
        }
        renderStep();
        window.scrollTo(0, 0);
    }
}


// Carousel functions - completely rewritten for reliable swiping


// Carousel state - kept outside function to persist
let carouselInitialized = false;
let carouselCleanup = null;


function initCarousel() {
    const carouselStrip = document.getElementById('quiz-carousel-strip');
    const container = document.querySelector('.quiz-carousel-container');


    if (!carouselStrip || !container) return;


    // Clean up previous listeners if carousel was already initialized
    if (carouselCleanup) {
        carouselCleanup();
        carouselCleanup = null;
    }


    const imagesCount = 3;
    const swipeThreshold = 30; // Reduced threshold for easier swiping


    // State variables
    let isActive = false;
    let startX = null;
    let startY = null;
    let currentX = null;
    let hasMoved = false;


    // Unified handler functions for both touch and mouse
    function handleStart(clientX, clientY) {
        isActive = true;
        startX = clientX;
        startY = clientY;
        currentX = clientX;
        hasMoved = false;
        stopCarouselAutoRotation();
        carouselStrip.style.cursor = 'grabbing';
        carouselStrip.style.transition = 'none'; // Disable transition during drag
    }


    function handleMove(clientX, clientY, event) {
        if (!isActive || startX === null) return;


        currentX = clientX;
        const diffX = clientX - startX;
        const diffY = Math.abs(clientY - startY);
        const absDiffX = Math.abs(diffX);


        // If horizontal movement is greater than vertical, it's a swipe
        if (absDiffX > diffY && absDiffX > 5) {
            hasMoved = true;
            // Prevent page scroll during horizontal swipe
            if (event && event.cancelable) {
                event.preventDefault();
            }


            // Visual feedback: move strip slightly with finger/mouse
            const baseOffset = currentCarouselIndex * -100;
            const dragOffset = (diffX / container.offsetWidth) * 100;
            const maxDrag = 15; // Limit drag visual feedback
            const clampedDrag = Math.max(-maxDrag, Math.min(maxDrag, dragOffset));
            carouselStrip.style.transform = `translateX(calc(${baseOffset}% + ${clampedDrag}%))`;
        }
    }


    function handleEnd() {
        if (!isActive) return;


        const diffX = startX !== null && currentX !== null ? startX - currentX : 0;


        // Re-enable transition for snap animation
        carouselStrip.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)';
        carouselStrip.style.cursor = 'grab';


        // Process swipe if movement exceeded threshold
        if (Math.abs(diffX) > swipeThreshold && hasMoved) {
            if (diffX > 0) {
                // Swiped Left -> Next Image
                const nextIndex = (currentCarouselIndex + 1) % imagesCount;
                changeCarouselImage(nextIndex);
            } else {
                // Swiped Right -> Previous Image
                const prevIndex = currentCarouselIndex === 0 ? imagesCount - 1 : currentCarouselIndex - 1;
                changeCarouselImage(prevIndex);
            }
        } else {
            // Snap back to current image
            changeCarouselImage(currentCarouselIndex);
        }


        // Reset state
        isActive = false;
        startX = null;
        startY = null;
        currentX = null;
        hasMoved = false;


        // Restart auto-rotation after a delay
        setTimeout(() => {
            if (!isActive) {
                startCarouselAutoRotation();
            }
        }, 500);
    }


    // Touch Event Handlers
    function onTouchStart(e) {
        if (e.touches.length === 1) {
            handleStart(e.touches[0].clientX, e.touches[0].clientY);
        }
    }


    function onTouchMove(e) {
        if (e.touches.length === 1) {
            handleMove(e.touches[0].clientX, e.touches[0].clientY, e);
        }
    }


    function onTouchEnd(e) {
        handleEnd();
    }


    function onTouchCancel(e) {
        handleEnd();
    }


    // Mouse Event Handlers
    function onMouseDown(e) {
        e.preventDefault(); // Prevent image drag ghost
        handleStart(e.clientX, e.clientY);
    }


    function onMouseMove(e) {
        if (isActive) {
            e.preventDefault();
            handleMove(e.clientX, e.clientY, e);
        }
    }


    function onMouseUp(e) {
        handleEnd();
    }


    function onMouseLeave(e) {
        if (isActive) {
            handleEnd();
        }
    }


    // Attach event listeners to the container (not strip) for better touch capture
    container.addEventListener('touchstart', onTouchStart, { passive: true });
    container.addEventListener('touchmove', onTouchMove, { passive: false });
    container.addEventListener('touchend', onTouchEnd, { passive: true });
    container.addEventListener('touchcancel', onTouchCancel, { passive: true });


    // Mouse events on strip for desktop
    carouselStrip.addEventListener('mousedown', onMouseDown);
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
    carouselStrip.addEventListener('mouseleave', onMouseLeave);


    // Set initial cursor
    carouselStrip.style.cursor = 'grab';


    // Store cleanup function to remove listeners later
    carouselCleanup = function() {
        container.removeEventListener('touchstart', onTouchStart);
        container.removeEventListener('touchmove', onTouchMove);
        container.removeEventListener('touchend', onTouchEnd);
        container.removeEventListener('touchcancel', onTouchCancel);
        carouselStrip.removeEventListener('mousedown', onMouseDown);
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
        carouselStrip.removeEventListener('mouseleave', onMouseLeave);
    };


    carouselInitialized = true;


    // Start auto-rotation
    startCarouselAutoRotation();
}


function claimDiscountWithAnimation() {
    const button = document.getElementById('quiz-claimDiscountBtn');
    const buttonSpinner = button.querySelector('.quiz-button-spinner');
    const buttonCheckmark = button.querySelector('.quiz-button-checkmark');


    // Disable button to prevent multiple clicks
    button.disabled = true;
    button.style.cursor = 'not-allowed';


    // Show spinner (text and arrow stay visible)
    buttonSpinner.classList.remove('quiz-hidden');


    // After 1.5 seconds, hide spinner and show checkmark
    setTimeout(() => {
        buttonSpinner.classList.add('quiz-hidden');
        buttonCheckmark.classList.remove('quiz-hidden');
        buttonCheckmark.classList.add('quiz-show');


        // After showing checkmark for 1 second, proceed to next step
        setTimeout(() => {
            nextStep();
        }, 1000);
    }, 1500);
}


function changeCarouselImage(index) {
    const strip = document.getElementById('quiz-carousel-strip');
    const dots = document.querySelectorAll('.quiz-carousel-dot');


    if (!strip) return;


    // Update global index
    currentCarouselIndex = index;


    // Move the strip using transform
    strip.style.transform = `translateX(-${index * 100}%)`;


    // Update dots
    dots.forEach((dot, i) => {
        dot.classList.toggle('quiz-active', i === index);
    });
}


function startCarouselAutoRotation() {
    stopCarouselAutoRotation();


    const imagesCount = 3;
    carouselInterval = setInterval(() => {
        const nextIndex = (currentCarouselIndex + 1) % imagesCount;
        changeCarouselImage(nextIndex);
    }, 3000); // Auto-advance every 3 seconds
}


function stopCarouselAutoRotation() {
    if (carouselInterval) {
        clearInterval(carouselInterval);
        carouselInterval = null;
    }
}

